export interface PhoneCountryConfig {
  countryName: string;
  countryAbbreviation: string;
  prefixLength: number;
  flagEmoji: string;
}

export const PHONE_COUNTRY_CONFIG: Record<string, PhoneCountryConfig> = {
  '+54': {
    countryName: 'Argentina',
    countryAbbreviation: 'AR',
    prefixLength: 2,
    flagEmoji: '🇦🇷'
  },
  '+591': {
    countryName: 'Bolivia',
    countryAbbreviation: 'BO',
    prefixLength: 3,
    flagEmoji: '🇧🇴'
  },
  '+55': {
    countryName: 'Brasil',
    countryAbbreviation: 'BR',
    prefixLength: 2,
    flagEmoji: '🇧🇷'
  },
  '+56': {
    countryName: 'Chile',
    countryAbbreviation: 'CL',
    prefixLength: 2,
    flagEmoji: '🇨🇱'
  },
  '+57': {
    countryName: 'Colombia',
    countryAbbreviation: 'CO',
    prefixLength: 2,
    flagEmoji: '🇨🇴'
  },
  '+506': {
    countryName: 'Costa Rica',
    countryAbbreviation: 'CR',
    prefixLength: 3,
    flagEmoji: '🇨🇷'
  },
  '+53': {
    countryName: 'Cuba',
    countryAbbreviation: 'CU',
    prefixLength: 2,
    flagEmoji: '🇨🇺'
  },
  '+593': {
    countryName: 'Ecuador',
    countryAbbreviation: 'EC',
    prefixLength: 3,
    flagEmoji: '🇪🇨'
  },
  '+503': {
    countryName: 'El Salvador',
    countryAbbreviation: 'SV',
    prefixLength: 3,
    flagEmoji: '🇸🇻'
  },
  '+502': {
    countryName: 'Guatemala',
    countryAbbreviation: 'GT',
    prefixLength: 3,
    flagEmoji: '🇬🇹'
  },
  '+509': {
    countryName: 'Haití',
    countryAbbreviation: 'HT',
    prefixLength: 3,
    flagEmoji: '🇭🇹'
  },
  '+504': {
    countryName: 'Honduras',
    countryAbbreviation: 'HN',
    prefixLength: 3,
    flagEmoji: '🇭🇳'
  },
  '+52': {
    countryName: 'México',
    countryAbbreviation: 'MX',
    prefixLength: 2,
    flagEmoji: '🇲🇽'
  },
  '+505': {
    countryName: 'Nicaragua',
    countryAbbreviation: 'NI',
    prefixLength: 3,
    flagEmoji: '🇳🇮'
  },
  '+507': {
    countryName: 'Panamá',
    countryAbbreviation: 'PA',
    prefixLength: 3,
    flagEmoji: '🇵🇦'
  },
  '+595': {
    countryName: 'Paraguay',
    countryAbbreviation: 'PY',
    prefixLength: 3,
    flagEmoji: '🇵🇾'
  },
  '+51': {
    countryName: 'Perú',
    countryAbbreviation: 'PE',
    prefixLength: 2,
    flagEmoji: '🇵🇪'
  },
  '+1': {
    countryName: 'Puerto Rico / Rep. Dominicana',
    countryAbbreviation: 'PR/DO',
    prefixLength: 1,
    flagEmoji: '🇵🇷'
  },
  '+598': {
    countryName: 'Uruguay',
    countryAbbreviation: 'UY',
    prefixLength: 3,
    flagEmoji: '🇺🇾'
  },
  '+58': {
    countryName: 'Venezuela',
    countryAbbreviation: 'VE',
    prefixLength: 2,
    flagEmoji: '🇻🇪'
  }
};
